import { IAbExperimentsState } from './types';

export const AB_EXPERIMENT_DEFAULTS: IAbExperimentsState = {
  ha387_newPublishTerms: null,
};
